import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'

import type { PackagesAlertBody } from '../alertHover.types'
import { packagesStyles } from './Packages.styles'

const PackagesBody: React.FC<{ body: PackagesAlertBody }> = ({ body }) => {
  const { t } = useTranslation('alerts')

  if (!body) {
    return null
  }

  return (
    <Box sx={packagesStyles.root}>
      {body?.membership?.map((m, i) => (
        <Box key={i} sx={packagesStyles.row}>
          <Typography sx={packagesStyles.label}>{m.name}</Typography>
          <Typography sx={packagesStyles.membershipValue}>
            {t('packages.used', { count: m.used })}
          </Typography>
        </Box>
      ))}

      {body?.credits?.map((c, i) => (
        <Box key={i} sx={packagesStyles.row}>
          <Box sx={packagesStyles.bulletWrapper}>
            <Box component="span" sx={packagesStyles.bullet}>
              •
            </Box>
            <Typography sx={packagesStyles.label}>{c.label}</Typography>
          </Box>

          <Typography sx={packagesStyles.creditsValue}>
            {t('packages.left', { count: c.left })}
          </Typography>
        </Box>
      ))}
    </Box>
  )
}

export default PackagesBody
